import gql from '@/services/gql';
import session from '@/services/session';

export interface User {
  id: string;
  email: string;
}

interface Response {
  user: User[];
}

const requestUser = gql<Response>(`
  query getUser {
    user(
      limit: 1
    ) {
      id
      email
    }
  }
`);

const sessionKey = 'u';

const clearFromSession = () => {
  session.clear(sessionKey);

  // reset user id tracking
  analytics.reset();
};

const getFromSession = (): User => (
  JSON.parse(session.get(sessionKey) || '{}')
);

const storeInSession = () => (
  requestUser().then(response => {
    const [user] = response.user;
    if (user) {
      const output = JSON.stringify(user);
      session.set(sessionKey, output);

      // track user
      analytics.identify(user.id, {
        email: user.email,
      });
      return user;
    }
    throw {
      code: 'USER_NOT_FOUND',
    };
  })
);

export default {
  clearFromSession,
  getFromSession,
  storeInSession,
};
